import React from 'react';

const MobileMenuToggle = ({ className, icon, text, onClick, numberBadge }) => {
	return (
		<button onClick={onClick} className={`mobiletoggle button ${className}`}>
			{ icon ? <span className={`icon ${icon}`}></span> : null}
			{ text }
			{ numberBadge ? <span className="button-badge">{numberBadge}</span> : null}
		</button>
	);
};

export default MobileMenuToggle;
